import { render } from "./presupuesto.vue?vue&type=template&id=3d2d9c02"
import script from "./presupuesto.vue?vue&type=script&lang=js"
export * from "./presupuesto.vue?vue&type=script&lang=js"

import "./presupuesto.vue?vue&type=style&index=0&id=3d2d9c02&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__